import React, { useState, useMemo, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import productA from '../Images/MC1.png';
import productAD from '../Images/MC1D.png';
import productB from '../Images/MC 02.png';
import productBD from '../Images/MC 02D.png';
import productC from '../Images/MC 03.png';
import productCD from '../Images/MC 03D.png';
import productD from '../Images/MC 04.png';
import productDD from '../Images/MC 04D.png';
import productE from '../Images/MC 05.png';
import productED from '../Images/MC 05D.png';
import productF from '../Images/MC 500.png';
import productFD from '../Images/MC500D.png';
import productG from '../Images/MC55.png';
import productGD from '../Images/MC55D.png';
import productH from '../Images/BlockCrete.png';
import productHD from '../Images/BCD.png';
import productI from '../Images/Hardner.png';
import productID from '../Images/HD.png';
import '../CSS/Product.css';

// SEO Meta Tags and Structured Data
const updateSEO = () => {
  // Update page title
  document.title = 'MUSCLECRETE Products | Premium Adhesive & Cement Solutions | PAC Corporation';

  // Update or create meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = 'Discover MUSCLECRETE premium concrete coatings, adhesive solutions, and cement products from PAC Corporation. High-performance construction materials for professional and industrial use';

  // Update or create meta keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    document.head.appendChild(metaKeywords);
  }
  metaKeywords.content = 'MUSCLECRETE, PAC Corporation, concrete coating, adhesive, cement, MC coating, Block Crete, concrete adhesive, industrial coating, construction materials, hardener, concrete solution';

  // Open Graph tags for social sharing
  const ogTags = {
    'og:title': 'MUSCLECRETE Products | Premium Adhesive & Cement Solutions',
    'og:description': 'High-quality concrete coatings and adhesive products from PAC Corporation. Professional-grade construction materials.',
    'og:type': 'website',
    'og:url': window.location.href,
  };

  Object.entries(ogTags).forEach(([property, content]) => {
    let tag = document.querySelector(`meta[property="${property}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('property', property);
      document.head.appendChild(tag);
    }
    tag.content = content;
  });

  // Add JSON-LD Structured Data
  let structuredData = document.querySelector('script[type="application/ld+json"]');
  if (structuredData) {
    structuredData.remove();
  }

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    'name': 'PAC Corporation',
    'alternateName': 'MUSCLECRETE',
    'description': 'PAC Corporation manufactures premium concrete coatings, adhesive solutions, and cement products under the MUSCLECRETE brand.',
    'url': window.location.href,
    'product': [
      {
        '@type': 'Product',
        'name': 'MUSCLECRETE MC Series Coatings',
        'description': 'Professional-grade concrete coating solutions',
        'brand': { '@type': 'Brand', 'name': 'MUSCLECRETE' }
      },
      {
        '@type': 'Product',
        'name': 'Block Crete',
        'description': 'High-quality concrete product for construction',
        'brand': { '@type': 'Brand', 'name': 'MUSCLECRETE' }
      },
      {
        '@type': 'Product',
        'name': 'MC Hardner',
        'description': 'Concrete hardening agent and adhesive additive',
        'brand': { '@type': 'Brand', 'name': 'MUSCLECRETE' }
      }
    ]
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
};

const products = [
  { id: 1, name: 'MC 01', price: "Contact for quote", category: 'Coating', image: productA, detailimage: productAD, description: 'Premium MUSCLECRETE concrete coating solution - professional grade adhesive coating for construction' },
  { id: 2, name: 'MC 02', price: "Contact for quote", category: 'Coating', image: productB, detailimage: productBD, description: 'MUSCLECRETE MC 02 professional grade coating - high-performance concrete adhesive and protective coating' },
  { id: 3, name: 'MC 03', price: "Contact for quote", category: 'Coating', image: productC, detailimage: productCD, description: 'Advanced MUSCLECRETE protective coating - premium cement-based adhesive solution for durability' },
  { id: 4, name: 'MC 04', price: "Contact for quote", category: 'Coating', image: productD, detailimage: productDD, description: 'Industrial strength MUSCLECRETE coating - heavy-duty concrete adhesive for demanding applications' },
  { id: 5, name: 'MC 05', price: "Contact for quote", category: 'Coating', image: productE, detailimage: productED, description: 'High-performance MuskleCrete coating - superior concrete adhesive and protective solution' },
  { id: 6, name: 'MC 500', price: "Contact for quote", category: 'Coating', image: productF, detailimage: productFD, description: 'Premium MUSCLECRETE MC 500 coating - advanced adhesive formula for professional construction' },
  { id: 7, name: 'MC 55', price: "Contact for quote", category: 'Coating', image: productG, detailimage: productGD, description: 'Specialized MUSCLECRETE MC 55 formula - professional concrete adhesive and coating product' },
  { id: 8, name: 'Block Crete', price: "Contact for quote", category: 'Concrete', image: productH, detailimage: productHD, description: 'High-quality MUSCLECRETE Block Crete - premium concrete product with superior adhesive properties' },
  { id: 9, name: 'MC Hardner', price: "Contact for quote", category: 'Additive', image: productI, detailimage: productID, description: 'MUSCLECRETE MC Hardner - concrete hardening agent and adhesive additive from PAC Corporation' },
];

const categories = ['All', ...new Set(products.map(p => p.category))];

const Products = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sortBy, setSortBy] = useState('name');
  const [selectedForComparison, setSelectedForComparison] = useState([]);

  // Update SEO on component mount
  useEffect(() => {
    updateSEO();
    window.scrollTo(0, 0);
  }, []);

  const filteredProducts = useMemo(() => {
    let filtered = products.filter(product => {
      const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          product.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          'musclerete pac corporation adhesive cement coating'.includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });

    // Sorting
    if (sortBy === 'name') {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === 'newest') {
      filtered.reverse();
    }

    return filtered;
  }, [searchTerm, selectedCategory, sortBy]);

  const toggleComparison = (productId) => {
    if (selectedForComparison.includes(productId)) {
      setSelectedForComparison(selectedForComparison.filter(id => id !== productId));
    } else if (selectedForComparison.length < 4) {
      setSelectedForComparison([...selectedForComparison, productId]);
    }
  };

  return (
    <section className="products-page">
      <header className="products-header">
        <h1>MUSCLECRETE Products | Premium Concrete Coatings & Adhesive Solutions</h1>
        <p className="products-subtitle">Explore our premium coating and concrete solutions from PAC Corporation</p>
      </header>

      <div className="products-container">
        {/* Filter Sidebar */}
        <aside className="filter-sidebar">
          <div className="filter-section">
            <h3>Filter Products</h3>
            
            <div className="filter-group">
              <label className="filter-label">Search</label>
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="filter-input"
              />
            </div>

            <div className="filter-group">
              <label className="filter-label">Category</label>
              <div className="filter-options">
                {categories.map(category => (
                  <label key={category} className="filter-checkbox">
                    <input
                      type="radio"
                      name="category"
                      value={category}
                      checked={selectedCategory === category}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    />
                    <span>{category}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="filter-group">
              <label className="filter-label">Sort By</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="filter-select"
              >
                <option value="name">Product Name (A-Z)</option>
                <option value="newest">Newest First</option>
              </select>
            </div>

            {selectedForComparison.length > 0 && (
              <div className="filter-group">
                <button className="compare-btn">
                  Compare ({selectedForComparison.length}/4)
                </button>
              </div>
            )}
          </div>
        </aside>

        {/* Product Grid */}
        <main className="products-main">
          <div className="products-header-bar">
            <div className="product-count">
              Showing {filteredProducts.length} of {products.length} products
            </div>
            <div className="sort-controls">
              <label htmlFor="sort-mobile">Sort:</label>
              <select
                id="sort-mobile"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="sort-select-mobile"
              >
                <option value="name">Product Name</option>
                <option value="newest">Newest First</option>
              </select>
            </div>
          </div>

          <div className="product-grid" role="main" aria-label="MUSCLECRETE product listing">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <div key={product.id} className="product-with-comparison">
                  <ProductCard {...product} />
                  <label className="comparison-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedForComparison.includes(product.id)}
                      onChange={() => toggleComparison(product.id)}
                      disabled={!selectedForComparison.includes(product.id) && selectedForComparison.length >= 4}
                    />
                    <span>Compare</span>
                  </label>
                </div>
              ))
            ) : (
              <div className="no-results">
                <p>No MUSCLECRETE products found matching your search.</p>
                <p className="no-results-hint">Try searching for "concrete coating", "adhesive", "cement", or browse our MUSCLECRETE product categories</p>
              </div>
            )}
          </div>
        </main>
      </div>
    </section>
  );
};

export default Products;